import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { WebUxTitle } from '../WebUxContext';
import { Button, Input, Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useEventListener } from '../../common/EventContext';
import { useConnection } from '../../connection/connection';
import { useBusinessContext } from '../../context/BusinessContext';
import { EmailTemplate } from '../../dto/EmailTemplate';
import EmailTemplateEditModal, {
  useEmailTemplateEditModal,
} from './EmailTemplateEditModal';

type Props = {};

export const EmailTemplatesPage: FC<Props> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<EmailTemplate[]>([]);
  const connection = useConnection();
  const business = useBusinessContext();
  const [search, setSearch] = useState<string>();
  const modal = useEmailTemplateEditModal();

  const columns: any = useMemo(
    () => [
      {
        key: 'name',
        title: 'Name',
        dataIndex: 'name',
      },
      {
        key: 'actions',
        title: '',
        dataIndex: 'id',
        render: (text: string, record: any) => (
          <Button type="link" onClick={() => modal.current?.edit(record.id)}>
            <EditOutlined />
          </Button>
        ),
      },
    ],
    [modal],
  );
  useEffect(() => {
    setLoading(true);
    connection
      .get<EmailTemplate[]>(`email-templates`)
      .then((res) => setItems(res.data))
      .finally(() => setLoading(false));
  }, [business.businessId, connection]);

  useEventListener(
    'EMAIL_TEMPLATE',
    useCallback((dt) => {
      const item: EmailTemplate = dt.data;
      if (dt.action === 'CREATE') {
        setItems((prevState) => [item, ...prevState]);
      } else if (dt.action === 'UPDATE') {
        setItems((prevState) =>
          prevState.map((a) => (a.id === item.id ? item : a)),
        );
      }
    }, []),
  );

  const EmailTemplates = useMemo(() => {
    if (!search || search.trim() === '') {
      return items;
    }
    const s = search.trim().toLowerCase();
    return items.filter((item) => item.name.toLowerCase().includes(s));
  }, [items, search]);

  return (
    <div className="flex flex-col gap-2">
      <WebUxTitle>Email Templates</WebUxTitle>
      <div className="flex gap-1 justify-between">
        <div className="w-[500px]">
          <Input.Search
            onSearch={setSearch}
            allowClear={true}
            className="w-full"
            placeholder="Search EmailTemplate by name"
          />
        </div>
        <Button type="primary" onClick={() => modal.current?.open()}>
          Create Email Template
        </Button>
      </div>
      <Table
        size="small"
        loading={loading}
        pagination={false}
        columns={columns}
        dataSource={EmailTemplates}
      />
      <EmailTemplateEditModal ref={modal} />
    </div>
  );
};
